import { render } from "./SetupProgress.vue?vue&type=template&id=1320202b"
import script from "./SetupProgress.vue?vue&type=script&lang=js"
export * from "./SetupProgress.vue?vue&type=script&lang=js"

import "./SetupProgress.vue?vue&type=style&index=0&id=1320202b&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__